import React from 'react';
import {
    Form,
    Button,
    Table,
    Input,
    Select,
    Checkbox,
    TextArea,
    Popup,
    Header,
} from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';


// attributes
// attributeNames
// availableAttributeNames
export default class ConfigTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            addMode: false,
            editModeId: null,
            newName: '',
            newValue: '',
            newEngValue: '',

            newNameErr: false,
            newValueErr: false
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleBooleanToggle = this.handleBooleanToggle.bind(this);
        this._activateEditMode = this._activateEditMode.bind(this);
        this._activateAddMode = this._activateAddMode.bind(this);
        this._cancelAddMode = this._cancelAddMode.bind(this);
        this._cancelEditMode = this._cancelEditMode.bind(this);
        this._saveEditMode = this._saveEditMode.bind(this);
        this._saveAddMode = this._saveAddMode.bind(this);
        this._deleteAttribute = this._deleteAttribute.bind(this);
        this._getAttributeMetaByName = this._getAttributeMetaByName.bind(this);
        this._isBooleanAttribute = this._isBooleanAttribute.bind(this);
        this._isTranslatableAttribute = this._isTranslatableAttribute.bind(this);
        this._getTranslationValue = this._getTranslationValue.bind(this);
        this._isBooleanValueChecked = this._isBooleanValueChecked.bind(this);
        this._shouldMergeLanguageColumns = this._shouldMergeLanguageColumns.bind(this);
        this._renderBooleanDisplay = this._renderBooleanDisplay.bind(this);
        this._renderBooleanEditor = this._renderBooleanEditor.bind(this);
    }

    _getAttributeMetaByName(attributeName) {
        return this.props.attributeNames.find(el => el.name === attributeName) || null;
    }

    _isBooleanAttribute(attributeMeta) {
        return attributeMeta && attributeMeta.attributeType === 'BOOLEAN';
    }

    _isTranslatableAttribute(attributeMeta) {
        return !attributeMeta || attributeMeta.translatable !== false;
    }

    _getTranslationValue(attribute) {
        return attribute && attribute.translations && attribute.translations.length
            ? attribute.translations[0].value
            : '';
    }

    _isBooleanValueChecked(value) {
        if (typeof value === 'boolean') {
            return value;
        }

        if (value === null || value === undefined) {
            return false;
        }

        const normalized = String(value).trim().toLowerCase();
        return normalized === 'true'
            || normalized === '1'
            || normalized === 'yes'
            || normalized === 'y'
            || normalized === 'da'
            || normalized === 'on';
    }

    _shouldMergeLanguageColumns(isBoolean, isTranslatable) {
        return isBoolean || !isTranslatable;
    }

    handleBooleanToggle(event, { name, checked }) {
        this.setState({
            [name]: checked ? 'true' : 'false'
        });
    }

    _renderBooleanDisplay(value) {
        const checked = this._isBooleanValueChecked(value);

        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <Checkbox toggle checked={checked} disabled />
            </div>
        );
    }

    _renderBooleanEditor(value) {
        const checked = this._isBooleanValueChecked(value);

        return (
            <div style={{ display: 'flex', alignItems: 'center', minHeight: '38px' }}>
                <Checkbox
                    toggle
                    name="newValue"
                    checked={checked}
                    onChange={this.handleBooleanToggle}
                />
            </div>
        );
    }

    componentDidMount() {
        this.props.fetchAttributes();
        this.props.fetchAttributesNames();
    }

    // TODO: set first as selected in availableAttributeNames
    handleInputChange(event) {
        const { target } = event;
        const {
            type,
            checked,
            value,
            name,
        } = target;
        const normalizedValue = type === 'checkbox' ? checked : value;

        this.setState({
            [name]: normalizedValue
        });
    }

    handleChange(event, { name, value }) {
        if (name === 'newName') {
            this.setState({
                newNameErr: false,
                newValueErr: false,
                newName: value,
                // Reset dependent values when selected attribute/type changes.
                newValue: '',
                newEngValue: '',
            });
            return;
        }

        this.setState({
            newNameErr: false,
            newValueErr: false,
            [name]: value
        });
    }
    _activateAddMode() {
        this.setState({
            addMode: true,
            editModeId: null,
            newName: '',
            newValue: '',
            newEngValue: ''
        });
    }
    _activateEditMode(id) {
        const selected = this.props.attributes.find(el => el.id === id);
        const selectedMeta = this._getAttributeMetaByName(selected.name);
        const isTranslatable = this._isTranslatableAttribute(selectedMeta);
        this.setState({
            addMode: false,
            editModeId: id,
            newName: selected.name,
            newValue: selected.value,
            newEngValue: isTranslatable && selected.translations.length ? selected.translations[0].value : ''
        });
    }
    _cancelAddMode() {
        this.setState({
            addMode: false,
            editModeId: null,
            newName: '',
            newValue: '',
            newNameErr: false,
            newValueErr: false,
        });
    }
    _cancelEditMode() {
        this.setState({
            addMode: false,
            editModeId: null,
            newName: '',
            newValue: '',
            newNameErr: false,
            newValueErr: false,
        });
    }
    _saveAddMode() {
        const { newName, newValue, newEngValue } = this.state;

        if (!newName || !newValue) {
            toast('Niste unijeli sva polja!');
            if (!newName) { this.setState({ newNameErr: true }); } else { this.setState({ newNameErr: false }); }
            if (!newValue) { this.setState({ newValueErr: true }); } else { this.setState({ newValueErr: false }); }
        } else {
            const selectedAttributeId = Number(newName);
            const findSimpleNameAttribute = this.props.availableAttributeNames.find(el => el.key === selectedAttributeId);
            const isBoolean = this._isBooleanAttribute(findSimpleNameAttribute);
            const isTranslatable = this._isTranslatableAttribute(findSimpleNameAttribute);
            const shouldSendEnglishValue = !this._shouldMergeLanguageColumns(isBoolean, isTranslatable);
            this.props.saveNewAttribute(
                findSimpleNameAttribute.name,
                findSimpleNameAttribute.text,
                newValue,
                shouldSendEnglishValue ? newEngValue : null
            );
            this.setState({
                addMode: false,
                editModeId: null,
                newName: '',
                newValue: '',
                newEngValue: '',
                newNameErr: false,
                newValueErr: false,
            });
        }
    }
    _saveEditMode() {
        const {
            newName,
            newValue,
            editModeId,
            newEngValue,
        } = this.state;
        const findSimpleNameAttribute = this.props.attributeNames.find(el => el.name === newName);
        const { displayName } = findSimpleNameAttribute;
        const isBoolean = this._isBooleanAttribute(findSimpleNameAttribute);
        const isTranslatable = this._isTranslatableAttribute(findSimpleNameAttribute);
        const shouldSendEnglishValue = !this._shouldMergeLanguageColumns(isBoolean, isTranslatable);
        this.props.saveEditedAttribute(editModeId, newName, displayName, newValue, shouldSendEnglishValue ? newEngValue : null);
        this.setState({
            addMode: false,
            editModeId: null,
            newName: '',
            newValue: '',
        });
    }
    _deleteAttribute(id) {
        this.props.deleteAttribute(id);
        this.setState({
            addMode: false,
            editModeId: null,
            newName: '',
            newValue: '',
        });
    }
    render() {
        const {
            addMode,
            editModeId,
            newName,
            newValue,
            newEngValue,
        } = this.state;
        const selectedAddMeta = this.props.availableAttributeNames.find(el => el.key === Number(newName));
        const addIsBoolean = this._isBooleanAttribute(selectedAddMeta);
        const addIsTranslatable = this._isTranslatableAttribute(selectedAddMeta);
        const addMergeLanguageColumns = this._shouldMergeLanguageColumns(addIsBoolean, addIsTranslatable);
        const sortedAttributes = [...this.props.attributes].sort((a, b) => {
            const aMeta = this._getAttributeMetaByName(a.name);
            const bMeta = this._getAttributeMetaByName(b.name);
            const aIsBoolean = this._isBooleanAttribute(aMeta);
            const bIsBoolean = this._isBooleanAttribute(bMeta);

            if (aIsBoolean !== bIsBoolean) {
                return aIsBoolean ? -1 : 1;
            }

            const aOrder = aMeta && aMeta.orderNumber !== null && aMeta.orderNumber !== undefined
                ? Number(aMeta.orderNumber)
                : Number.MAX_SAFE_INTEGER;
            const bOrder = bMeta && bMeta.orderNumber !== null && bMeta.orderNumber !== undefined
                ? Number(bMeta.orderNumber)
                : Number.MAX_SAFE_INTEGER;

            if (aOrder !== bOrder) {
                return aOrder - bOrder;
            }

            const aLabel = (a.displayName || a.name || '').toLowerCase();
            const bLabel = (b.displayName || b.name || '').toLowerCase();
            return aLabel.localeCompare(bLabel);
        });

        const addNewAttributeSelect = (
            <Form>
                <Form.Field
                    required
                    error={this.state.newNameErr}
                    control={Select}
                    clearable
                    value={newName}
                    onChange={this.handleChange}
                    name="newName"
                    options={this.props.availableAttributeNames}
                    search
                    fluid
                    placeholder="Odaberite atribut"

                />
            </Form>
        );
        const addNewAttributeInput = (
            <Form>
                {addIsBoolean ? this._renderBooleanEditor(newValue) : <Form.Field
                    required
                    error={this.state.newValueErr}
                    control={Input}
                    name="newValue"
                    id="newValue"
                    value={newValue}
                    onChange={this.handleInputChange}
                />}
            </Form>
        );

        const addNewEngAttributeInput = (
            <Form>
                <Form.Field
                    control={Input}
                    name="newEngValue"
                    id="newEngValue"
                    value={newEngValue}
                    onChange={this.handleInputChange}
                />
            </Form>
        );

        return (
            <div>
                <Table structured celled selectable compact>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Atribut</Table.HeaderCell>
                            <Table.HeaderCell colSpan="2">
                                <Header as="h4">
                                    <Header.Content>
                                        Vrijednost
                                    </Header.Content>
                                    <Header.Subheader>B/H/S jezik</Header.Subheader>
                                </Header>
                            </Table.HeaderCell>
                            <Table.HeaderCell colSpan="2">
                                <Header as="h4">
                                    <Header.Content>
                                        Vrijednost
                                    </Header.Content>
                                    <Header.Subheader>Engleski jezik</Header.Subheader>
                                </Header>
                            </Table.HeaderCell>
                            <Table.HeaderCell as="th" verticalAlign="middle" textAlign="center">
                                <Popup
                                    content="Dodaj atribut"
                                    position="top center"
                                    trigger={
                                        <Button
                                            icon="add"
                                            size="small"
                                            basic="true"
                                            color="blue"
                                            circular
                                            onClick={() => this._activateAddMode()}
                                        />}
                                />
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {sortedAttributes.map(el => {
                            const attributeMeta = this._getAttributeMetaByName(el.name);
                            const isTranslatable = this._isTranslatableAttribute(attributeMeta);
                            const isBoolean = this._isBooleanAttribute(attributeMeta);
                            const translationValue = this._getTranslationValue(el);
                            const mergeLanguageColumns = this._shouldMergeLanguageColumns(isBoolean, isTranslatable);
                            return editModeId !== el.id ?
                                (<Table.Row>
                                    <Table.Cell verticalAlign="middle">{el.displayName}</Table.Cell>
                                    {mergeLanguageColumns ? (
                                        <Table.Cell verticalAlign="middle" colSpan="4">
                                            {isBoolean ? this._renderBooleanDisplay(el.value) : el.value}
                                        </Table.Cell>
                                    ) : (
                                        <React.Fragment>
                                            <Table.Cell verticalAlign="middle" colSpan="2">{el.value}</Table.Cell>
                                            <Table.Cell verticalAlign="middle" colSpan="2">{translationValue}</Table.Cell>
                                        </React.Fragment>
                                    )}

                                    <Table.Cell textAlign="center" verticalAlign="middle">
                                        <Popup
                                            content="Izmjena"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    basic="true"
                                                    circular
                                                    icon="pencil"
                                                    size="small"
                                                    color="green"
                                                    onClick={() => this._activateEditMode(el.id)}
                                                />}
                                        />
                                        <Popup
                                            content="Brisanje"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    basic="true"
                                                    circular
                                                    icon="trash alternate"
                                                    size="small"
                                                    color="red"
                                                    onClick={() => this._deleteAttribute(el.id)}
                                                />}
                                        />
                                    </Table.Cell>
                                </Table.Row>)
                                :
                                (<Table.Row>
                                    <Table.Cell>{el.displayName}</Table.Cell>
                                    {mergeLanguageColumns ? (
                                        <Table.Cell verticalAlign="middle" colSpan="4">
                                            <Form>
                                                {isBoolean ? this._renderBooleanEditor(newValue) : <Form.Field
                                                    control={this.props.studentService ? TextArea : Input}
                                                    name="newValue"
                                                    value={newValue}
                                                    onChange={this.handleInputChange}
                                                    defaultValue={el.value}
                                                />}
                                            </Form>
                                        </Table.Cell>
                                    ) : (
                                        <React.Fragment>
                                            <Table.Cell verticalAlign="middle" colSpan="2">
                                                <Form>
                                                    <Form.Field
                                                        control={this.props.studentService ? TextArea : Input}
                                                        name="newValue"
                                                        value={newValue}
                                                        onChange={this.handleInputChange}
                                                        defaultValue={el.value}
                                                    />
                                                </Form>
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle" colSpan="2">
                                                <Form>
                                                    <Form.Field
                                                        control={this.props.studentService ? TextArea : Input}
                                                        name="newEngValue"
                                                        value={newEngValue}
                                                        onChange={this.handleInputChange}
                                                        defaultValue={translationValue}
                                                    />
                                                </Form>
                                            </Table.Cell>
                                        </React.Fragment>
                                    )}
                                    <Table.Cell textAlign="center" >
                                        <Popup
                                            content="Sačuvaj"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    basic="true"
                                                    circular
                                                    icon="check"
                                                    size="small"
                                                    color="blue"
                                                    onClick={this._saveEditMode}
                                                />}
                                        />
                                        <Popup
                                            content="Poništi"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    basic="true"
                                                    circular
                                                    icon="delete"
                                                    size="small"
                                                    color="red"
                                                    onClick={() => this._cancelEditMode()}
                                                />}
                                        />
                                    </Table.Cell>
                                </Table.Row>);
                        })}

                        {addMode &&
                            <Table.Row >
                                <Table.Cell >{addNewAttributeSelect}</Table.Cell>
                                {addMergeLanguageColumns ? (
                                    <Table.Cell colSpan="4">{addNewAttributeInput}</Table.Cell>
                                ) : (
                                    <React.Fragment>
                                        <Table.Cell colSpan="2">{addNewAttributeInput}</Table.Cell>
                                        <Table.Cell colSpan="2">{addNewEngAttributeInput}</Table.Cell>
                                    </React.Fragment>
                                )}
                                <Table.Cell textAlign="center">
                                    <Popup
                                        content="Sačuvaj"
                                        position="top center"
                                        trigger={
                                            <Button
                                                basic="true"
                                                circular
                                                icon="check"
                                                size="small"
                                                color="blue"
                                                onClick={this._saveAddMode}
                                            />}
                                    />
                                    <Popup
                                        content="Poništi"
                                        position="top center"
                                        trigger={
                                            <Button
                                                basic="true"
                                                circular
                                                icon="delete"
                                                size="small"
                                                color="red"
                                                onClick={this._cancelAddMode}
                                            />}
                                    />
                                </Table.Cell>
                            </Table.Row>
                        }
                    </Table.Body>
                </Table>
                <ToastContainer hideProgressBar />
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/views/DocumentTemplateConfiguration/ConfigTable.js